import axios from "axios";
import ErrorParser from '../error.parser';

const ValidateService = {
  networks: async function () {
    const requestData = {
      method: "get",
      url: "/api/qualitycontrol/validate/networks",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  dataset: async function (id, from, to) {
    const requestData = {
      method: "post",
      url: "/api/qualitycontrol/validate/dataset",
      data: {
        id: id,
        from: from,
        to: to
      }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      let message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  validate: async function (rowsToValidate) {
    const requestData = {
      method: "post",
      url: "/api/qualitycontrol/validate/validate",
      data: { flags: rowsToValidate }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  observations: async function (oc_id, from, to, onlyValidValues, viewAsBar) {
    const requestData = {
      method: "post",
      url: "/api/qualitycontrol/validate/observations",
      data: { oc_id, from, to, onlyValidValues, viewAsBar}
    };
    console.log("REQUEST", requestData);
    
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default ValidateService;
